module.exports = __webpack_public_path__ + "img/DSCF5694.244ad296.jpeg";